module.exports = new __parcel__URL__("bg_stars_box_01.4538f61a.jpg").toString();